const ENV = {
  REACT_APP_PSE_RECAPTCHA_SITE_KEY:
    process.env.REACT_APP_PSE_RECAPTCHA_SITE_KEY,
};

export default ENV;
